import logo from "assets/images/MS-BLUE-LTD-logo-1.png"
import bgImage from "assets/images/Group-127.png"
import bgHomeSvg from "assets/images/Group-72.png"

export const images={
    logo:logo,
    bgImage:bgImage,
    bgHomeSvg:bgHomeSvg
}